import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { CircularProgress } from '@mui/material';
import { deleteGroup } from '../../api/groups';

import { _showAlert } from '../../utils';

import '../CustomerList/CustomerList.scss';

const DeleteGroupPopup = ({ selectedGroup, setIsDeletePopUpVisible, setSelectedGroup }) => {
  const [isLoading, setIsLoading] = useState(false);

  const { name } = selectedGroup || {};


  const deleteCustomer = async () => {
    try {
      setIsLoading(true);
      await deleteGroup(selectedGroup.id);
      setIsLoading(false);
      setIsDeletePopUpVisible(false);
      _showAlert('group deleted successfully!!', 'sucess');
      setSelectedGroup(null);
    } catch (error) {
      setIsLoading(true);
      _showAlert(error.message, 'error');
    }
  };

  return (
    <div className="modalBackDrop" style={{ zIndex: 10 }} onClick={() => setIsDeletePopUpVisible(false)}>
      <div className="blockUserModal" style={{ height: 'auto' }} onClick={(e) => e.stopPropagation()}>
        <p
          className="label"
          style={{ marginTop: '30px', marginBottom: '10px', width: '90%' }}
        >{`Are you sure you want to delete ${name} group? `}</p>
        <div className="btnContainer">
          {isLoading ? (
            <div style={{ marginRight: '20px' }}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <Button variant="outlined" color="error" onClick={deleteCustomer}>
                Yes
              </Button>
              <Button variant="outlined" onClick={() => setIsDeletePopUpVisible(false)}>
                No
              </Button>{' '}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteGroupPopup;

